/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { IncomingCarePlan } from "./IncomingCarePlan";
import type { IncomingCuraiRedirect } from "./IncomingCuraiRedirect";
import type { IncomingOutreachText } from "./IncomingOutreachText";

export interface IncomingOutreachModel {
  conversation_owner_id: string;
  sender_full_name_with_title?: string | null;
  deduplication_id: string;
  event?: IncomingOutreachText | null;
  events?:
    | (IncomingOutreachText | IncomingCarePlan | IncomingCuraiRedirect)[]
    | null;
  /** The ID of the clinic request this outreach is associated with */
  clinic_request_id?: string | null;
}
